import Header from './components/Header';
import Hero from './components/Hero';
import { FAQSection, ContactSection, TopicsSection, CardsSection } from './components/SectionGroupA';
import { MediaSection, RankingSection, FeaturesSection, UpdatesSection } from './components/SectionGroupB';
import { AppSection, AboutSection, CarouselSection, IndexSection, CommentsSection } from './components/SectionGroupC';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />

        <FAQSection />

        <ContactSection />

        <TopicsSection />

        <CardsSection />

        <MediaSection />

        <RankingSection />

        <FeaturesSection />

        <UpdatesSection />

        <AppSection />

        <AboutSection />

        <CarouselSection />

        <IndexSection />

        <CommentsSection />
      </main>

      <Footer />
    </div>
  );
}